import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/legal/")({
  component: LegalPage,
});

function LegalPage() {
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-primary hover:text-primary/80 transition-colors mb-4"
          >
            ← Back to Home
          </Link>
          <h1 className="text-4xl font-bold text-foreground mb-2">
            Legal Information
          </h1>
          <p className="text-muted-foreground">
            Important policies and legal documents
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          <Link
            to="/privacy"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary/50 transition-colors"
          >
            <h2 className="text-2xl font-semibold text-foreground mb-2">
              Privacy Policy
            </h2>
            <p className="text-muted-foreground">
              How we collect, use, and protect your information, including
              Google user data. Last updated: July 27, 2026
            </p>
          </Link>

          <Link
            to="/terms"
            className="block p-6 bg-card border border-border rounded-lg hover:border-primary/50 transition-colors"
          >
            <h2 className="text-2xl font-semibold text-foreground mb-2">
              Terms of Service
            </h2>
            <p className="text-muted-foreground">
              The terms governing your use of FlowState Automate. Last updated:
              July 27, 2026
            </p>
          </Link>
        </div>

        <div className="mt-12 p-6 bg-muted/30 rounded-lg">
          <h2 className="text-xl font-semibold text-foreground mb-4">
            Questions?
          </h2>
          <p className="text-muted-foreground">
            If you have any questions about our legal documents, please contact us.
          </p>
        </div>
      </div>
    </div>
  );
}